<template>
  <Modal v-model="editModal" title="编辑分配权重" width="800"  :mask-closable="false" v-drag-modal>
    <Form ref="modalForm" class="form"
          :model="formData" :rules="formRule"
          :label-width="90">
      <Row>
        <Col :span="12">
          <FormItem label="选择课顾分组">
            <Select v-model="formData.teamType" @on-change="onTeamTypeChange">
              <Option v-for="item in $constant.adviserGroup" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <ul>
          <li v-for="item in formData.adviserList">
            <Col :span="12">
              <FormItem :label="item.adviserName">
                <Input v-model="item.weight" @on-change="onWeightChange" placeholder="权重"/>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="渠道分类">
                <Select v-model="item.channelTypes" @on-change="onTypeChange" clearable multiple transfer placement="top">
                  <Option v-for="item in $constant.channelTypeEnum" :value="item.id" :key="item.id">{{ item.text }}</Option>
                </Select>
              </FormItem>
            </Col>
          </li>
        </ul>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="primary" size="large" @click="editModal=false">取消</Button>
      <Button type="primary" size="large" :loading="insertLoading" @click="confirmAssign">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import AdminUserMultSelect from '../common/AdminUserMultSelect.vue'

export default {
    name: 'editAssignWeightModal',
    components: {AdminUserMultSelect},
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let $constant = this.$constant
      return {
        insertLoading: false,
        params: {
          adviserList: [],
          uids: [],
          type: 1
        },
        formData: {
          totalNum: 0,
          remainder: 0,
          teamType: 0,
          adviserList: [],
        },
        formRule: {

        }
      }
    },
    mounted: function () {
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      getAdviserList (teamType) {
        let self = this
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.formData.adviserList = res.data
          }
        })
      },
      onTeamTypeChange (value) {
        this.getAdviserList(value)
      },
      onTypeChange () {
        let self = this
        var list = self.formData.adviserList
        self.params.adviserList = []
        var index = 0
        for (; index < list.length; index++) {
          self.params.adviserList.push(list[index])
        }
      },
      onWeightChange () {
        let self = this
        var sumCount = 0
        var list = self.formData.adviserList
        self.params.adviserList = []
        var index = 0
        for (; index < list.length; index++) {
          var weight = parseInt(list[index].weight)
          sumCount += weight
          self.params.adviserList.push(list[index])
        }
        self.formData.remainder = self.formData.totalNum - sumCount
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      confirmAssign () {
        let self = this
        self.$http.post('/adviser/updateAdviserInfos', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.params)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!')
            self.editModal = false
            self.successCallback()
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.getAdviserList(0)
        }
      },
      userList (array) {
        this.params.uids = []
        this.formData.totalNum = array.length
        this.formData.remainder = array.length
        for (var i = 0; i < array.length; i++) {
          this.params.uids.push(array[i].id)
        }
      }
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// EditAssignWeightModal.vue?07c36b5c